import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { HotelRepository } from '@core/services/repositories/hotel.repository'

@Component({
  selector: 'iho-downloads-app',
  templateUrl: './downloads-app.component.html',
  styleUrls: ['./downloads-app.component.scss'],
  standalone: true,
  providers: [HotelRepository],
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
    
]
})

export class DdownloadsAppComponent implements OnInit {

  constructor( ) {
  }
  ngOnInit(): void {
   
  
}


}
